import React, { useState } from 'react';
import Modal from 'react-modal';
import { AxiosResponse } from 'axios';
import AddToAvailabilityList from './AddToAvailabilityList';
import EnableDisable from './EnableDisable';
import MarkUnsuitable from './MarkUnsuitable';
import { QuickActions, QuickActionItem } from '../common/quickActions';
import SendSMSContainer from '../operations/freelancers/send_sms';
import SendNotificationContainer from '../operations/freelancers/SendNotification';
import { TFreelancerData, TPageNotification, TUser } from '../../types';

type TFreelancerDetailsQuickActionsProps = {
    freelancerData: TFreelancerData;
    setFreelancerData: (data: TFreelancerData) => void;
    notification: TPageNotification;
    onSave: (fields: any) => Promise<AxiosResponse>;
    user: TUser;
}

export default function FreelancerDetailsQuickActions({
    freelancerData,
    setFreelancerData,
    notification,
    onSave,
    user,
}: TFreelancerDetailsQuickActionsProps) {

    const [showNotification, setShowNotification] = useState(false);
    const [showSms, setShowSms] = useState(false);
    const [showEnableDisable, setShowEnableDisable] = useState(false);

    const sendMessageActions = (
        user.agency.features.includes('dashboard_sms')
        && user.permissions.includes('auth.sms_dashboard_allowed')
    ) && (
        <>
            <QuickActionItem
                label="Send notification"
                icon="icon-email-send-1"
                onClick={() => setShowNotification(true)}
            />
            <QuickActionItem
                label="Send SMS"
                icon="icon-email-2"
                onClick={() => setShowSms(true)}
            />
            <Modal
                className="none"
                contentLabel="Notification Modal"
                isOpen={showNotification}
            >
                <SendNotificationContainer
                    freelancers={[freelancerData]}
                    notification={notification}
                    closeModal={() => setShowNotification(false)}
                    isUnallocatedFreelancersRoute={false}
                />
            </Modal>
            <Modal
                className="none"
                contentLabel="SMS Modal"
                isOpen={showSms}
            >
                <SendSMSContainer
                    freelancers={[freelancerData]}
                    notification={notification}
                    closeModal={() => setShowSms(false)}
                    isUnallocatedFreelancersRoute={false}
                />
            </Modal>
        </>
    );

    const availabilityListAction = (
        <AddToAvailabilityList
            freelancers={[freelancerData]}
            notification={notification}
        />
    );

    const enableDisableAction = !freelancerData.is_unsuitable && (
        <>
            <QuickActionItem
                label={freelancerData.is_active ? 'Disable' : 'Enable'}
                icon={freelancerData.is_active ? 'icon-logout-2' : 'icon-login-2'}
                onClick={() => setShowEnableDisable(true)}
            />
            <EnableDisable
                freelancerData={freelancerData}
                setFreelancerData={setFreelancerData}
                notification={notification}
                isOpen={showEnableDisable}
                setIsOpen={setShowEnableDisable}
            />
        </>
    );

    const markUnsuitableAction = (freelancerData.published || freelancerData.is_unsuitable) && (
        <MarkUnsuitable
            freelancer={freelancerData}
            notification={notification}
            onSave={onSave}
        />
    );

    const actions = [
        sendMessageActions,
        availabilityListAction,
        enableDisableAction,
        markUnsuitableAction,
    ];

    return <QuickActions actions={actions} />;
}
